import { useState } from '@wordpress/element';
import { Button, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const Settings = () => {
    const [setting, setSetting] = useState('');

    const handleSave = () => {
        alert('Setting saved: ' + setting);
    };

    return (
        <div className="p-4 bg-white rounded shadow-md">
            <h1 className="text-2xl font-bold mb-4">{ __('Settings', 'my-plugin') }</h1>
            <p>{ __( 'Coming soon! Keep an eye out for this awesome new addition.', 'universal-blocks' ) }</p>
        </div>
    );
};

export default Settings;
